// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3ZtZL","label":"Labeled_label__d72uB","divider":"Labeled_divider__1qZOY"};